import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, Validators } from '@angular/forms';

@Pipe({
  name: 'requiredAsterisk',
  standalone: true,
})
export class RequiredAsteriskPipe implements PipeTransform {
  transform(control: AbstractControl): string {
    return control && control.hasValidator(Validators.required) ? '*' : '';
  }
}
